export const API_URL_FETCH_SHOP_AVAILABILITY_FOR_PICKUP = "/shop/api/shopavailabilityforpickupbyorder/";
export const API_URL_FETCH_SHOP_AVAILABILITY_FOR_PICKUP_BY_SKU = (skus: string) =>
    `/shop/api/shopavailabilityforpickupbysku/${skus}`;
